import React from 'react';
import { useNavigate } from 'react-router-dom';
import LegalFooter from './LegalFooter.jsx';
import { POLICY_VERSION, SUPPORT_EMAIL } from '../utils/legal';
import '../styles/legal.css';
import '../styles/appHeader.css';

const PrivacyPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <header className="app-header glass">
        <div className="app-header-logo">
          <button type="button" className="logo-text-home" onClick={() => navigate('/')}>
            LiveNow
          </button>
        </div>
      </header>
      <article className="legal-page">
        <h1>Privacy Policy</h1>
        <p className="legal-meta">Version {POLICY_VERSION}. Controller contact: {SUPPORT_EMAIL}. LiveNow is operated from Portugal.</p>
        <h2>What we collect</h2>
        <p>
          If you create an account we store your email, optional display name and photo, searches,
          interests, bookmarks, reminders, notification preferences, and connected platform accounts.
          Guest search uses a random visitor id in your browser so we can apply a daily quota.
          We do not use that id to build a profile.
        </p>
        <h2>Why we collect it</h2>
        <p>
          To run search, send alerts you ask for, remember your settings, and keep the service secure.
          Cookie or similar storage is limited to sign-in and visitor quota.
        </p>
        <h2>Sharing</h2>
        <p>
          Search uses platforms and TV/EPG sources. Auth is handled by Supabase. We do not sell
          your personal data.
        </p>
        <h2>Your rights</h2>
        <p>
          You can export or delete your account from Profile, Account. Export is a JSON file of your
          data. Delete removes your personal records and sign-in user. Catalog events stay in LiveNow
          unlinked from you. Email {SUPPORT_EMAIL} if something fails.
        </p>
        <h2>Contact</h2>
        <p>
          Questions: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </article>
      <LegalFooter />
    </div>
  );
};

export default PrivacyPage;
